<template>
    <div><span v-if="slug" :class="{
        badge: true,
        [`badge-request-credit-status-${slug}`]: true,
    }">{{status_text}}</span></div>
</template>

<script>
    import RequestCreditStatusData from "../../plugins/request_credit_status_data";
    export default {
        name: "RequestCreditStatusBadge",
        props: ['slug'],
        computed: {
            status_text: function () {
                if (!this.slug) return "";
                return RequestCreditStatusData.data()[this.slug].label;
            },
        },
    }
</script>

<style scoped>

</style>
